import script from "./SellerOrdersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerOrdersPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerOrdersPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__